import { MAIN_COLOR, MAIN_HOVER_COLOR } from 'shared/consts/styleValues';
import styled, { css } from 'styled-components';

interface Button {
	$isChecked: boolean;
}

export const Button = styled.button<Button>`
	color: ${MAIN_COLOR};
	padding: 8px 0;
	border-radius: 48px;
	background-color: transparent;

	${props =>
		props.$isChecked &&
		css`
			background-color: ${MAIN_COLOR};
			color: white;
		`}

	border: 1px solid ${MAIN_COLOR};
	border-radius: 24px;
	padding: 8px;
	font-size: 15px;
	margin-bottom: 8px;
	font-weight: 600;

	transition: background-color 0.3s ease, border-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: rgba(87, 124, 240, 0.1);
		border-color: ${MAIN_COLOR};

		${props =>
			props.$isChecked &&
			css`
				background-color: ${MAIN_HOVER_COLOR};
				color: 'white';
			`}
	}
`;
